import React, { useContext, useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Fade,
  Backdrop
} from '@mui/material';
import { ReviewContext } from '../ReviewContext';
import { showSwalNotification } from '../../utils/SwalResponse';

const AddReplyModal = ({ review, reload, setReload }) => {
  const {addReviewReply} = useContext(ReviewContext)
  const [replyText, setReplyText] = useState('');
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    if (replyText.trim()) {
      // console.log({reply_text:replyText, review_id:review?.review_id})
      const response = await addReviewReply({reply_text:replyText, review_id:review?.review_id});
      
      if (response?.status === 'success'){
        setReplyText('');
        showSwalNotification(response)
        handleClose();
        setReload(!reload)
        setError(null)
      } else {
        setError(`${response?.status || 'Error'}: ${response?.message || 'Something went wrong.'}`);
      }
    }
  };

  return (
    <>
    {/* <Box textAlign="right" mt={1}> */}
    <Button
        size="small"
        onClick={handleOpen}
        sx={{
          fontWeight: 600,
          textTransform: "none",
          "&:hover": { textDecoration: "underline" },
        }}
    >
      ↩️ Reply
    </Button>
    {/* </Box> */}
    
    <Modal
    open={open}
    onClose={handleClose}
    closeAfterTransition
    slots={{ backdrop: Backdrop }}
    slotProps={{
      backdrop: {
        timeout: 300,
      },
    }}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }} // <-- This ensures perfect vertical & horizontal centering
  >
    <Fade in={open}>
      <Box
        sx={{
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 24,
          p: 4,
          width: '90%',
          maxWidth: 500,
          outline: 'none',
          position: 'absolute',
        }}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        transition={{ type: 'spring', stiffness: 300, damping: 25 }}
      >
          <Typography variant="h6" className="mb-3 fw-bold text-success">
            Reply to {review?.user?.name}
          </Typography>
          <TextField
            label="Reply"
            fullWidth
            multiline
            rows={6}
            variant="outlined"
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
          />

          {error && (
            <Typography color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}
          <Box className="mt-4 d-flex justify-content-end gap-2">
            <Button onClick={handleClose} variant="outlined" color="error">
              Cancel
            </Button>
            <Button onClick={handleSubmit} variant="contained" color="success">
              Submit Reply
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
    </>
  );
};

export default AddReplyModal;
